import * as contactPersonTypesList from './contactPersonTypesList';

import {combineReducers} from "redux";
import {all, fork} from "redux-saga/effects";

export interface IState  {
    List: contactPersonTypesList.IState
}

export const ActionCreators = {
    List: contactPersonTypesList.ActionCreators,
}

export const Reducers = combineReducers<IState>({
    List: contactPersonTypesList.Reducers,
});

export function* sagas() {
    yield all([
        fork(contactPersonTypesList.sagas),
    ]);
}
